// theme.ts
import { createTheme } from '@mui/material/styles';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import createCache from '@emotion/cache';

// 1. Create the MUI theme with RTL direction
const theme = createTheme({
  direction: 'rtl',
  // You can add palette, typography etc. here
});

// 2. Create Emotion cache with RTL plugin
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

export { theme, cacheRtl };
